import React from 'react'
import CreatableSelect from 'react-select/lib/Creatable';

const CreatableInput = ({ fieldData }) => {
  return (
    <CreatableSelect
      isMulti
      value={fieldData.value}
      onChange={fieldData.onChange}
      options={fieldData.options}
      placeholder={fieldData.placeholder}
    />
  );
}

export default CreatableInput



// WEBPACK FOOTER //
// ./src/components/generic/CreatableInput.js